export default "__VITE_ASSET__4ed8ea15__"